import { render, staticRenderFns } from "./StepFiles.vue?vue&type=template&id=c8e2324c&"
import script from "./StepFiles.vue?vue&type=script&lang=js&"
export * from "./StepFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8e2324c')) {
      api.createRecord('c8e2324c', component.options)
    } else {
      api.reload('c8e2324c', component.options)
    }
    module.hot.accept("./StepFiles.vue?vue&type=template&id=c8e2324c&", function () {
      api.rerender('c8e2324c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/61221000-4/numerationFiles/StepFiles.vue"
export default component.exports